module.exports = __webpack_public_path__ + "img/emoji_meigui.7f7772f5.png";